
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M13.5 13.5H2.215c-.395 0-.715-.296-.715-.662V4.5"}}),_c('path',{attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M3.5 3.245c0-.412.355-.745.792-.745H14.75c.437 0 .792.333.792.745v7.51c0 .411-.355.745-.792.745H4.292c-.437 0-.792-.334-.792-.745z"}}),_c('path',{attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M15.5 4.5 9.5 8l-6-3.5"}})])
          )
        }
      }
    